document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('#product-specs')) {
    document.querySelector('.product-resources_specs')?.classList.add('hidden');
  }

  if (!document.querySelector('#product-resources')) {
    document.querySelector('.product-resources_resources')?.classList.add('hidden');
  }
  window.productSwiper = new Swiper('.main-product-container .product__media-gallery', {
    spaceBetween: 10,
    slidesPerView: 1,
    freeMode: true,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.main-product-container .swiper-button-next',
      prevEl: '.main-product-container .swiper-button-prev',
    },
    pagination: {
      el: '.main-product-container .swiper-pagination',
    },
    on: {
      init() {
        console.log('product info slider init()!');
      },
    },
  });

  const gallery = GLightbox({
    selector: 'data-glightbox-pd',
  });

  setVariantImage();

  function setVariantImage() {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const paramValue = url.searchParams.get('variant');
    const current_variant_id = paramValue ?? window.first_or_available;
    let data_image_id = document.querySelector('.main-product-container .variant_image-' + current_variant_id);
    if (data_image_id) {
      let slide_id = data_image_id.getAttribute('data-slide');
      window.productSwiper.slideTo(slide_id);
    }
  }
});
